import { ExpediaLogoConfig } from './expedia-logo.config';

export const BannerLogoConfig = {
  ...ExpediaLogoConfig,
};
